import { hasOwnProp } from '@/api/ApiHelpers'
import { configuredWaterYearForDate } from '@/utils/waterYears'

export default async function ({ $auth, store, $repositories }) {
  if ($auth.$state.user) {
    if (JSON.stringify(store.state.omsettings.all) === '{}') {
      await store.dispatch('omsettings/list')
    }

    if (!store.state.system.availableWaterYears.length || store.state.system.availableWaterYears.length < Object.values(store.state.omsettings.all).length) {
      const result = await $repositories.getWaterYears.index()
      if (!result || hasOwnProp(result, 'error')) {
        return
      }
      store.commit('system/SET_ALL_WATER_YEARS', result)
    }

    let waterYear = store.state.system.waterYear

    if (!waterYear) {
      waterYear = configuredWaterYearForDate(store.state.omsettings.all)
    }

    if (!waterYear) {
      return
    }

    await store.dispatch('system/setWaterYear', waterYear)
  }
}
